import { Divider, Header, Icon, Segment, Tab, Table } from 'semantic-ui-react';
import { observer } from 'mobx-react-lite';
import { userLanguage } from '../../../app/common/userLanguageSchema/userLanguage';
import { useStore } from '../../../app/stores/store';
import { useEffect } from 'react';
import BarcodeGenerator from '../../../app/common/modals/BarCode/BarCodeGenerator';
import QRCode from 'qrcode.react';

export default observer(function PhysicalMetaData({ id }: { id: string }) {
  const {
    commonStore,
    viewStore: {
      getPhysicalAssets,
      physicalAssets,
      HFCphysicalAssets,
      getHFCPhysical,
      getHFCPhysicalAssets,
    },
    userStore:{user},
    activityStore:{selectedActivity:Activity}
  } = useStore();
  const changeDateTime = (data: string) => {
    return new Date(data).toLocaleString();
  };

  useEffect(() => {
    if (id) {
      if (commonStore.hfcCustomerChanges) {
        getHFCPhysical({itemId: id})
        getHFCPhysicalAssets({ itemId: id });
      }else{
        getPhysicalAssets({ itemId: id });
      }
    }
    // eslint-disable-next-line
  }, [id]);

  return (
    <Tab.Pane
      className={
        commonStore.filterModeZero?.includes('AVLAVF02')
          ? 'component-isDisabled metadata-parent-tab'
          : 'metadata-parent-tab'
      }
    >
      <Segment.Group className={'MetaDataUser'}>
        <Divider horizontal>
          <Header color="teal" as="h4">
            <Icon
              name="film"
              //Physical Assets
            />
            {
              (
                userLanguage[0]
                  .AssetsViewItemLevelViewPagesSidebarTabpanePhysical
                  .AVILVPSTPPL01 as any
              )?.[`${commonStore.language.key}`]
            }
          </Header>
        </Divider>
        <Table definition>
          <Table.Body>
           {user?.customerName === 'PCPLCRM' && Activity?.parent?.split('/')[1]?.includes('Client & PRASAD ASSET TRACKING') ? <> </> :  <Table.Row>
              <Table.Cell width={7}>
                {' '}
                {
                  commonStore.hfcCustomerChanges ? (<strong>Asset Id</strong>) :(
                    <strong
                //Physical Sensor NFC
                >
                  {
                    (
                      userLanguage[0]
                        .AssetsViewItemLevelViewPagesSidebarTabpanePhysical
                        .AVILVPSTPPL02 as any
                    )?.[`${commonStore.language.key}`]
                  }
                </strong>
                  )
                }
              </Table.Cell>
              <Table.Cell width={7}>
                {commonStore.hfcCustomerChanges ? HFCphysicalAssets.assetId : physicalAssets?.physical_sensor_NFC}
              </Table.Cell>
            </Table.Row>}
            <Table.Row>
              <Table.Cell width={7}>
              {
                  commonStore.hfcCustomerChanges ? ( <strong>Container Barcodes</strong>) :
                  user?.customerName === 'PCPLCRM' && Activity?.parent?.split('/')[1]?.includes('Client & PRASAD ASSET TRACKING') ? 'BarCode' :
                (<strong
                //Physcial Sensor BarCode
                >
                  {
                    (
                      userLanguage[0]
                        .AssetsViewItemLevelViewPagesSidebarTabpanePhysical
                        .AVILVPSTPPL03 as any
                    )?.[`${commonStore.language.key}`]
                  }
                </strong>)}
              </Table.Cell>
              <Table.Cell width={7}>
                {commonStore.hfcCustomerChanges ? HFCphysicalAssets.container_Barcodes 
                : user?.customerName === 'PCPLCRM' && Activity?.parent?.split('/')[1]?.includes('Client & PRASAD ASSET TRACKING') 
                ? <BarcodeGenerator id={physicalAssets?.physical_sensor_barcode || Activity?.id} isScan={false} /> 
                : physicalAssets?.physical_sensor_barcode}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell width={7}>
              {
                  commonStore.hfcCustomerChanges ? ( <strong>Reel Barcode</strong>) :
                  user?.customerName === 'PCPLCRM' && Activity?.parent?.split('/')[1]?.includes('Client & PRASAD ASSET TRACKING') ? 'QR Code' :
                <strong
                //Physcial Sensor QRCode
                >
                  {
                    (
                      userLanguage[0]
                        .AssetsViewItemLevelViewPagesSidebarTabpanePhysical
                        .AVILVPSTPPL04 as any
                    )?.[`${commonStore.language.key}`]
                  }
                </strong>}
              </Table.Cell>
              <Table.Cell width={7}>
                {commonStore.hfcCustomerChanges ? HFCphysicalAssets.reel_Barcodes 
                : user?.customerName === 'PCPLCRM' && Activity?.parent?.split('/')[1]?.includes('Client & PRASAD ASSET TRACKING') 
                ? <QRCode
                value={physicalAssets?.physical_sensor_qrcode  || Activity?.id}
                id="canvas"
                style={{
                  width: '190px',
                  height: '200px',
                  marginLeft: '18%',
                  marginRight: 'auto',
                  marginBottom: '10px',
                }}
              />
                // ? <QrCodeGenerator id={physicalAssets?.physical_sensor_qrcode  || Activity?.id} isScan={false} /> 
                : physicalAssets?.physical_sensor_qrcode}
              </Table.Cell>
            </Table.Row>
           {user?.customerName === 'PCPLCRM' && Activity?.parent?.split('/')[1]?.includes('Client & PRASAD ASSET TRACKING') ? <> </> : <><Table.Row>
              <Table.Cell width={7}>
              {
                  commonStore.hfcCustomerChanges ? ( <strong>Vault</strong>) :
                <strong
                //Physcial Sensor RFID
                >
                  {
                    (
                      userLanguage[0]
                        .AssetsViewItemLevelViewPagesSidebarTabpanePhysical
                        .AVILVPSTPPL05 as any
                    )?.[`${commonStore.language.key}`]
                  }
                </strong>}
              </Table.Cell>
              <Table.Cell width={7}>
                {commonStore.hfcCustomerChanges ? HFCphysicalAssets.vault : physicalAssets?.physical_sensor_RFID}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell width={7}>
                {
                  commonStore.hfcCustomerChanges ? (<strong>Room</strong>) :
                <strong
                //Physcial Location Rack
                >
                  {
                    (
                      userLanguage[0]
                        .AssetsViewItemLevelViewPagesSidebarTabpanePhysical
                        .AVILVPSTPPL06 as any
                    )?.[`${commonStore.language.key}`]
                  }
                </strong>}
              </Table.Cell>
              <Table.Cell width={7}>
                {commonStore.hfcCustomerChanges ? HFCphysicalAssets.room : physicalAssets?.physical_location_rack}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell width={7}>
                {
                  commonStore.hfcCustomerChanges ? (<strong>Aisle No</strong>) :
                <strong
                //Physical Location Shelf
                >
                  {
                    (
                      userLanguage[0]
                        .AssetsViewItemLevelViewPagesSidebarTabpanePhysical
                        .AVILVPSTPPL07 as any
                    )?.[`${commonStore.language.key}`]
                  }
                </strong>}
              </Table.Cell>
              <Table.Cell width={7}>
                {commonStore.hfcCustomerChanges ? HFCphysicalAssets.aisle_No : physicalAssets?.physical_location_shelf}
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell width={7}>
              {
                  commonStore.hfcCustomerChanges ? (<strong>Shelf</strong>) :
                <strong
                //Physcial Location Vault
                >
                  {
                    (
                      userLanguage[0]
                        .AssetsViewItemLevelViewPagesSidebarTabpanePhysical
                        .AVILVPSTPPL08 as any
                    )?.[`${commonStore.language.key}`]
                  }
                </strong>}
              </Table.Cell>
              <Table.Cell width={7}>
                {commonStore.hfcCustomerChanges ? HFCphysicalAssets.shelf : physicalAssets?.physical_location_vault}
              </Table.Cell>
            </Table.Row>
            { !commonStore.hfcCustomerChanges &&(
              <Table.Row>
              <Table.Cell width={7}>
                  <strong
                  //Global Positioning System
                  >
                    {
                      (
                        userLanguage[0]
                          .AssetsViewItemLevelViewPagesSidebarTabpanePhysical
                          .AVILVPSTPPL09 as any
                      )?.[`${commonStore.language.key}`]
                    }
                  </strong>
                </Table.Cell>
                <Table.Cell width={7}>
                  {physicalAssets?.global_positioning_system}{' '}
                </Table.Cell>
              </Table.Row>
              
            )}
            <Table.Row>
              <Table.Cell width={7}>
              {
                  commonStore.hfcCustomerChanges ? (<strong>Asset In Vault</strong>) :
                <strong
                //Movement Time
                >
                  {
                    (
                      userLanguage[0]
                        .AssetsViewItemLevelViewPagesSidebarTabpanePhysical
                        .AVILVPSTPPL11 as any
                    )?.[`${commonStore.language.key}`]
                  }
                </strong>}
              </Table.Cell>
              <Table.Cell width={7}>
                {commonStore.hfcCustomerChanges
                  ? HFCphysicalAssets.asset_In_Vault
                  : physicalAssets?.movement_Time === '0001-01-01T00:00:00'
                  ? 'N/A'
                  : changeDateTime(physicalAssets?.movement_Time)}{' '}
              </Table.Cell>

              {/* {changeDateTime(activity?.movement_Time)} */}
            </Table.Row></>}
            {commonStore.hfcCustomerChanges && (
              <>
                <Table.Row>
                  <Table.Cell width={7}>
                    <strong>Movement Time</strong>
                  </Table.Cell>
                  <Table.Cell width={7}>
                    {/* {hfcPhysical.pigeonHole} */}
                    {HFCphysicalAssets.movement_Time}
                  </Table.Cell>
                </Table.Row>
              </>
            )}
          </Table.Body>
        </Table>
      </Segment.Group>
    </Tab.Pane>
  );
});
